// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Divider from "@mui/material/Divider";

// Vero Software components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import ThemedLogo from "components/ThemedLogo";

// Vero Software examples
import DefaultInfoCard from "examples/Cards/InfoCards/DefaultInfoCard";

// Tech logos
import PythonLogo from "assets/images/pythonlogo.png";
import SqlServerLogo from "assets/images/sqlserver-logo.png";
import SnowflakeLogo from "assets/images/snowflakelogo.png";
import AzureLogo from "assets/images/azurelogo.png";
import ReactLogo from "assets/images/react-logo.png";
import PythonLogoDark from "assets/images/pythonlogo-dark.png";
import SqlServerLogoDark from "assets/images/sqlserver-logo-dark.png";
import SnowflakeLogoDark from "assets/images/snowflakelogo-dark.png";
import AzureLogoDark from "assets/images/azurelogo-dark.png";
import ReactLogoDark from "assets/images/react-logo-dark.png";

function Services() {
  return (
    <MKBox id="services" component="section" py={6} sx={{ scrollMarginTop: "120px" }}>
      <Container>
        <Grid container justifyContent="center" textAlign="center">
          <Grid item xs={12} md={8}>
            <MKTypography variant="h3" mb={1}>
              Software Services
            </MKTypography>
            <MKTypography variant="body1" color="text" mb={6}>
              We design, build, and run custom software &mdash; from the application layer down to
              the data underneath it. One team, one point of contact, end to end.
            </MKTypography>
          </Grid>
        </Grid>
        <Grid container spacing={3}>
          <Grid item xs={12} md={4}>
            <DefaultInfoCard
              direction="center"
              icon="code"
              title="Custom Software"
              description="Web and desktop applications built in .NET, Python, and JavaScript/React &mdash; designed around how your business actually works. We start by understanding your workflow, not by handing you a template, and we stick around after launch to support and extend what we build."
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <DefaultInfoCard
              direction="center"
              icon="insights"
              title="Data &amp; AI"
              description="Data pipelines, warehousing, and analytics on SQL Server and Snowflake, plus machine learning and generative AI where it earns its keep. We turn scattered data into something your team can actually query and trust &mdash; and we're honest when AI isn't the right tool for the job."
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <DefaultInfoCard
              direction="center"
              icon="cloud_done"
              title="Cloud &amp; Delivery"
              description="Cloud-hosted, agile delivery on Azure &mdash; sprint by sprint, with a backlog you help prioritize instead of a black box. You see working software early and often, and you can change direction without blowing up the timeline."
            />
          </Grid>
        </Grid>

        <Divider sx={{ my: 6 }} />

        <MKTypography
          variant="button"
          textTransform="uppercase"
          fontWeight="bold"
          color="text"
          textAlign="center"
          display="block"
          mb={3}
        >
          Built with
        </MKTypography>

        <Grid container spacing={3} justifyContent="center" alignItems="stretch">
          {[
            { src: PythonLogo, dark: PythonLogoDark, alt: "Python" },
            { src: SqlServerLogo, dark: SqlServerLogoDark, alt: "SQL Server" },
            { src: SnowflakeLogo, dark: SnowflakeLogoDark, alt: "Snowflake" },
            { src: AzureLogo, dark: AzureLogoDark, alt: "Azure" },
            { src: ReactLogo, dark: ReactLogoDark, alt: "React" },
          ].map(({ src, dark, alt }) => (
            <Grid item xs={4} md={2} key={alt}>
              <MKBox
                bgColor="surface"
                borderRadius="lg"
                shadow="sm"
                p={1.5}
                height="100%"
                display="flex"
                alignItems="center"
                justifyContent="center"
              >
                <ThemedLogo light={src} dark={dark} alt={alt} width="100%" />
              </MKBox>
            </Grid>
          ))}
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Services;
